export default __webpack_public_path__ + "static/media/GeraldandWineThumb400.85ee8223.jpg";